import React, { HTMLAttributes, ReactNode } from 'react';

type MapIconButtonProps = {
  id?: string;
  disabled?: boolean;
  children?: ReactNode;
  onClick?: VoidFunction;
  styles?: HTMLAttributes<HTMLButtonElement>['style'];
};
const MapIconButton: React.FC<MapIconButtonProps> = ({
  id,
  disabled,
  styles,
  onClick,
  children,
}: MapIconButtonProps) => (
  <button
    id={id}
    disabled={disabled}
    style={{
      backgroundColor: 'white',
      borderWidth: 0,
      borderRadius: 3,
      cursor: disabled ? 'not-allowed' : 'pointer',
      height: 44,
      outline: 'none',
      width: 44,
      ...styles,
    }}
    onClick={onClick}
  >
    {children}
  </button>
);

export default MapIconButton;
